/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RmCalculationType } from './RmCalculationType';
import {
    RmCalculationTypeFromJSON,
    RmCalculationTypeFromJSONTyped,
    RmCalculationTypeToJSON,
    RmCalculationTypeToJSONTyped,
} from './RmCalculationType';
import type { CalculationType } from './CalculationType';
import {
    CalculationTypeFromJSON,
    CalculationTypeFromJSONTyped,
    CalculationTypeToJSON,
    CalculationTypeToJSONTyped,
} from './CalculationType';
import type { RrpCalculationType } from './RrpCalculationType';
import {
    RrpCalculationTypeFromJSON,
    RrpCalculationTypeFromJSONTyped,
    RrpCalculationTypeToJSON,
    RrpCalculationTypeToJSONTyped,
} from './RrpCalculationType';

/**
 * 
 * @export
 * @interface CalculationSettingsRequestBody
 */
export interface CalculationSettingsRequestBody {
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    priceUnitId: number;
    /**
     * 
     * @type {CalculationType}
     * @memberof CalculationSettingsRequestBody
     */
    calculationType?: CalculationType;
    /**
     * 
     * @type {RmCalculationType}
     * @memberof CalculationSettingsRequestBody
     */
    rmCalculationType?: RmCalculationType;
    /**
     * 
     * @type {RrpCalculationType}
     * @memberof CalculationSettingsRequestBody
     */
    rrpCalculationType?: RrpCalculationType;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    fmcTarget: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    targetLpIndex: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    targetRrpIndex?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    breakEvenFactor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    priceThreshold: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    aboveThresholdMin: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    aboveThresholdMax: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    belowThresholdMin: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    belowThresholdMax: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsRequestBody
     */
    calculationBasisPriceUnitId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalculationSettingsRequestBody
     */
    enableAutoCalc: boolean;
}



/**
 * Check if a given object implements the CalculationSettingsRequestBody interface.
 */
export function instanceOfCalculationSettingsRequestBody(value: object): value is CalculationSettingsRequestBody {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('fmcTarget' in value) || value['fmcTarget'] === undefined) return false;
    if (!('targetLpIndex' in value) || value['targetLpIndex'] === undefined) return false;
    if (!('priceThreshold' in value) || value['priceThreshold'] === undefined) return false;
    if (!('aboveThresholdMin' in value) || value['aboveThresholdMin'] === undefined) return false;
    if (!('aboveThresholdMax' in value) || value['aboveThresholdMax'] === undefined) return false;
    if (!('belowThresholdMin' in value) || value['belowThresholdMin'] === undefined) return false;
    if (!('belowThresholdMax' in value) || value['belowThresholdMax'] === undefined) return false;
    if (!('enableAutoCalc' in value) || value['enableAutoCalc'] === undefined) return false;
    return true;
}

export function CalculationSettingsRequestBodyFromJSON(json: any): CalculationSettingsRequestBody {
    return CalculationSettingsRequestBodyFromJSONTyped(json, false);
}

export function CalculationSettingsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationSettingsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'priceUnitId': json['priceUnitId'],
        'calculationType': json['calculationType'] == null ? undefined : CalculationTypeFromJSON(json['calculationType']),
        'rmCalculationType': json['rmCalculationType'] == null ? undefined : RmCalculationTypeFromJSON(json['rmCalculationType']),
        'rrpCalculationType': json['rrpCalculationType'] == null ? undefined : RrpCalculationTypeFromJSON(json['rrpCalculationType']),
        'fmcTarget': json['fmcTarget'],
        'targetLpIndex': json['targetLpIndex'],
        'targetRrpIndex': json['targetRrpIndex'] == null ? undefined : json['targetRrpIndex'],
        'breakEvenFactor': json['breakEvenFactor'] == null ? undefined : json['breakEvenFactor'],
        'priceThreshold': json['priceThreshold'],
        'aboveThresholdMin': json['aboveThresholdMin'],
        'aboveThresholdMax': json['aboveThresholdMax'],
        'belowThresholdMin': json['belowThresholdMin'],
        'belowThresholdMax': json['belowThresholdMax'],
        'calculationBasisPriceUnitId': json['calculationBasisPriceUnitId'] == null ? undefined : json['calculationBasisPriceUnitId'],
        'enableAutoCalc': json['enableAutoCalc'],
    };
}

export function CalculationSettingsRequestBodyToJSON(json: any): CalculationSettingsRequestBody {
    return CalculationSettingsRequestBodyToJSONTyped(json, false);
}

export function CalculationSettingsRequestBodyToJSONTyped(value?: CalculationSettingsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'priceUnitId': value['priceUnitId'],
        'calculationType': CalculationTypeToJSON(value['calculationType']),
        'rmCalculationType': RmCalculationTypeToJSON(value['rmCalculationType']),
        'rrpCalculationType': RrpCalculationTypeToJSON(value['rrpCalculationType']),
        'fmcTarget': value['fmcTarget'],
        'targetLpIndex': value['targetLpIndex'],
        'targetRrpIndex': value['targetRrpIndex'],
        'breakEvenFactor': value['breakEvenFactor'],
        'priceThreshold': value['priceThreshold'],
        'aboveThresholdMin': value['aboveThresholdMin'],
        'aboveThresholdMax': value['aboveThresholdMax'],
        'belowThresholdMin': value['belowThresholdMin'],
        'belowThresholdMax': value['belowThresholdMax'],
        'calculationBasisPriceUnitId': value['calculationBasisPriceUnitId'],
        'enableAutoCalc': value['enableAutoCalc'],
    };
}

